import { render, staticRenderFns } from "./CreateCar.vue?vue&type=template&id=21ced1fe&scoped=true&"
import script from "./CreateCar.vue?vue&type=script&lang=js&"
export * from "./CreateCar.vue?vue&type=script&lang=js&"
import style0 from "./CreateCar.vue?vue&type=style&index=0&id=21ced1fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ced1fe",
  null
  
)

export default component.exports